import React from "react";
import "./Navbar.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";

export default function Navbar() {

  const closeNavbar = () => {
    const nav = document.getElementById("navMenu");
    if (nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-nav">
      <div className="container">

        {/* Logo */}
        <NavLink className="navbar-brand d-flex align-items-center" to="/" onClick={closeNavbar}>
          <img
            src={require("../../images/LandingPage/Cryptoants.png")}
            alt="Logo"
            className="logo-img"
          />
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">

            {/* Home */}
            <li className="nav-item">
              <NavLink
                to="/"
                end
                onClick={closeNavbar}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>

            {/* My View */}
            <li className="nav-item">
              <NavLink
                to="/myview"
                onClick={closeNavbar}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                My View
              </NavLink>
            </li>

            {/* Expert View */}
            <li className="nav-item">
              <NavLink
                to="/expertview"
                onClick={closeNavbar}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Expert View
              </NavLink>
            </li>

            {/* Publisher */}
            <li className="nav-item">
              <NavLink
                to="/publisher"
                onClick={closeNavbar}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Publisher
              </NavLink>
            </li>

          </ul>

          {/* Right Side */}
          <div className="nav-right">

            <div className="contact-text">
              <span>📞 Contact us : </span>
              <a href="tel:9321765323" className="contact-number">
                9321765323
              </a>
            </div>

            {/* Login Button */}
            <li className="nav-item">
              <NavLink
                to="/login"
                onClick={closeNavbar}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Login
              </NavLink>
            </li>

          </div>
        </div>

      </div>
    </nav>
  );
}